
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...friendlyUrlPath]]",
      function () {
        return require("private-next-pages/[[...friendlyUrlPath]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...friendlyUrlPath]]"])
      });
    }
  